<div class="flex flex-col w-full min-h-screen justify-start items-center px-4 sm:px-0 pt-6 sm:pt-4">
  <div class="flex flex-row h-[20%] sm:h-[25%] justify-center items-center w-full mb-4">
    <div class="flex flex-col shrink-0 w-24 sm:w-32 md:w-36 min-w-20 max-w-44 justify-center items-center">
      <img
        src="./assets/SafeTK-DragonSlayer-Logo.png"
        class="img img-fluid max-w-full h-auto"
      />
    </div>
  </div>

  <div
    class="border border-stilRed-200 bg-gray-100 rounded pl-4 pr-4 pt-0 pb-0 shadow-md flex flex-col w-full max-w-[280px] sm:max-w-[360px] md:max-w-[440px] lg:w-[480px] justify-center items-stretch min-h-[300px] pb-4 mb-4"
  >
    <form
      [formGroup]="loginForm"
      class="w-full"
      [ngClass]="{ 'animated shake': showInvalidCredsMsg }"
    >
      @if (showInvalidCredsMsg && !loggedInViaSSO) {
        <div
          id="invalid-credentials-msg"
          class="text-red-600 mb-1 text-sm sm:text-base"
        >
          <p>Invalid Credentials. Please try again.</p>
        </div>
      }

      @if (loggedInViaSSO && (showInvalidCredsMsg || loggedOut)) {
        <div class="text-red-600 mb-1 text-sm sm:text-base">
          @if (showInvalidCredsMsg) {
            <p>
              Invalid Credentials.
              <br />
              Login again or Start Over.
            </p>
          }

          @if (loggedOut) {
            <p>You have been logged out.</p>
          }

          <button
            [disabled]="loading"
            mat-flat-button
            (click)="startOver()"
            color="primary"
            class="py-3 sm:py-4 w-full !bg-stilRed-200 text-sm sm:text-base"
          >
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            Start Over
          </button>
        </div>
      }

      @if (connectionStringNames?.length > 1 && !(loggedInViaSSO && loggedOut)) {
        <div class="mb-2">
          <label
            class="py-2 text-sm sm:text-base w-full block"
            [class.is-invalid]="submitted && connectionStringNameCtrl.errors"
            for="connectionStringName"
          >
            Connection String Name
          </label>
          <select
            formControlName="connectionStringName"
            placeholder="Loading..."
            class="border p-2 sm:p-3 w-full rounded text-sm sm:text-base"
            [class.is-invalid]="submitted && connectionStringNameCtrl.errors"
          >
            @for (conn of connectionStringNames; track $index) {
              <option [value]="conn">
                {{ conn }}
              </option>
            }
          </select>

          @if (!connectionStringNames?.length) {
            <mat-progress-bar
              color="primary"
              mode="indeterminate"
            ></mat-progress-bar>
          }

          @if (submitted && connectionStringNameCtrl.errors?.required) {
            <div class="invalid-feedback text-xs sm:text-sm">Connection String Name is required</div>
          }
        </div>
      }

      @if (facilities?.length > 1 && !(loggedInViaSSO && loggedOut)) {
        <div class="mb-2">
          <label
            class="py-2 text-sm sm:text-base w-full block"
            [class.is-invalid]="submitted && facilityIdCtrl.errors"
            for="facilityId"
          >
            Facility
          </label>
          <select
            formControlName="facilityId"
            placeholder="Loading..."
            class="border border-gray-600 p-2 sm:p-3 w-full rounded text-sm sm:text-base"
            [class.is-invalid]="submitted && facilityIdCtrl.errors"
          >
            @for (facility of facilities; track facility.ID) {
              <option [value]="facility.ID">
                {{ facility.name }}
              </option>
            }
          </select>

          @if (submitted && facilityIdCtrl.errors?.required) {
            <div class="invalid-feedback text-xs sm:text-sm">Facility is required</div>
          }
        </div>
      }

      @if (!(useSSO || stilLoggingIn || loggedInViaSSO)) {
        <div class="mb-2">
          <label
            class="py-2 text-sm sm:text-base w-full block"
            [class.is-invalid]="submitted && usernameCtrl.errors"
            for="username"
          >
            Username
          </label>
          <input
            type="text"
            formControlName="username"
            class="border border-gray-600 p-2 sm:p-3 w-full rounded text-sm sm:text-base"
            [ngClass]="{ 'is-invalid': submitted && usernameCtrl.errors }"
          />

          @if (submitted && usernameCtrl?.errors?.required) {
            <div class="invalid-feedback text-xs sm:text-sm">Username is required</div>
          }
        </div>
      }

      @if (!(useSSO || stilLoggingIn || loggedInViaSSO)) {
        <div class="mb-2">
          <label
            class="py-2 text-sm sm:text-base w-full block"
            for="password"
            [class.is-invalid]="submitted && passwordCtrl.errors"
          >
            Password
          </label>
          <input
            type="password"
            formControlName="password"
            class="border border-gray-600 p-2 sm:p-3 w-full rounded text-sm sm:text-base"
            [class.is-invalid]="submitted && passwordCtrl.errors"
          />

          @if (submitted && passwordCtrl.errors.required) {
            <div class="invalid-feedback text-xs sm:text-sm">Password is required</div>
          }
        </div>
      }

      @if (!(loggedInViaSSO && loggedOut)) {
        <div class="mt-4">
          <button
            [disabled]="loading || (loginForm.touched && loginForm.invalid)"
            (click)="onSubmit()"
            mat-flat-button
            color="primary"
            class="py-3 sm:py-4 w-full !bg-stilRed-200 text-sm sm:text-base"
          >
            @if (loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }

            Login
          </button>
        </div>
      }
    </form>
  </div>

  <div
    id="version"
    class="text-xs sm:text-sm text-center px-4 py-2 w-full max-w-[280px] sm:max-w-[350px] md:max-w-[400px] lg:w-[400px]"
  >
    Build Version: {{ uiVersion }}
  </div>
</div>
